import { useEffect } from 'react';
import { AUTH_INITIAL_FOCUS_DELAY_MS } from 'common/constants/auth';

const useAuthInitialFocus = (focusTarget?: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled || !focusTarget) {
      return undefined;
    }

    // Defer focus until the next auth step has mounted and layout measurements have settled.
    const timeoutId = window.setTimeout(() => {
      focusTarget();
    }, AUTH_INITIAL_FOCUS_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, focusTarget]);
};

export default useAuthInitialFocus;
